module.exports = __webpack_public_path__ + "fonts/Roboto-Black.d182671.ttf";